export const fetchGameAnalysis = async (gamePk) => {
  const [playByPlayRes, boxScoreRes, linescore] = await Promise.all([
    fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/playByPlay`),
    fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/boxscore`),
    fetch(`https://statsapi.mlb.com/api/v1/game/${gamePk}/linescore`),
  ]);

  const playByPlay = playByPlayRes.ok ? await playByPlayRes.json() : null;
  const boxScore = boxScoreRes.ok ? await boxScoreRes.json() : null;
  const linescoreData = linescore.ok ? await linescore.json() : null;

  return { playByPlay, boxScore, linescoreData };
};